import React, { useEffect, useState } from "react";
import styled from "styled-components";
import GrayCard from "components/gray-card";
import Typography from "components/typography";
import { Colors } from "utils/colors";
import CheckBox from "components/check-box";
import { stores } from "constants/stores";

interface IProps {
  Stores: string[];
  setStores(stores: string[]): void;
}
const StepFive = ({ Stores, setStores }: IProps) => {
  const [checkedStores, setCheckedStores] = useState<string[]>([...Stores]);

  const removeStore = (store: string) => {
    const chosenStores = checkedStores.filter((val) => val !== store);

    setCheckedStores([...chosenStores]);
  };

  useEffect(() => {
    setStores(checkedStores);
  }, [checkedStores]);
  return (
    <Container>
      <GrayCard title="Digital Stores">
        <Typography color={Colors.grey400} mb="2.4">
          Select stores you would like to distribute your release to
        </Typography>
        <ItemGrid>
          {stores.map((store, i) => {
            return (
              <CheckItem key={i}>
                <CheckBox
                  defaultState={checkedStores.includes(store)}
                  onChange={() => {
                    if (checkedStores.includes(store)) {
                      removeStore(store);
                    } else {
                      setCheckedStores([...checkedStores, store]);
                    }
                  }}
                />
                <Typography ml="0.8" color={Colors.grey400} size="s">
                  {store}
                </Typography>
              </CheckItem>
            );
          })}
        </ItemGrid>
      </GrayCard>
    </Container>
  );
};

export default StepFive;

const Container = styled.div`
  width: 100%;
  position: relative;
  justify-content: center;
  height: 100%;
`;

const ItemGrid = styled.div`
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
  align-items: center;
  justify-content: space-between;
  grid-row-gap: 1.6rem;
  @media only screen and (max-width: 769px) {
    grid-template-columns: 50% 50%;
  }
`;

const CheckItem = styled.div`
  display: flex;
  align-items: center;
`;
